import React from 'react';

export function ListenerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 150 150"
      aria-labelledby="listenerIcon"
    >
      <title id="listenerIcon">Listener Icon</title>
      <rect width="150" height="150" fill="#97E0CE" rx="75" />
      <circle cx="75.8" cy="59.6" r="19.8" fill="#185941" />
      <path
        fill="#185941"
        d="M75 80.5c-14.8 0-27.4 11.7-31.1 27.7-1.3 5.4 3.3 10 8.9 10h44.6c5.5 0 10-4.6 8.8-10-3.7-16-16.2-27.7-31.1-27.7z"
      />
      <path
        stroke="#185941"
        strokeWidth="5"
        d="M96.7 71.8V53c0-11.4-9.3-20.8-20.8-20.8v0A20.8 20.8 0 0055.1 53v18.8"
      />
      <path
        fill="#fff"
        d="M46.1 68.3c-.8-4.4 2.4-8.6 7.2-9.4 4.7-.7 4.7 3 5.5 7.3.9 4.4 2.3 7.9-2.5 8.7-4.8.7-9.3-2.2-10.2-6.6z"
      />
      <rect
        width="5.9"
        height="20.5"
        fill="#97E0CE"
        rx="2.9"
        transform="matrix(-.98716 .15975 -.18867 -.98204 61.3 76.2)"
      />
      <path
        fill="#fff"
        d="M105.8 68.3c-.9 4.4-5.4 7.3-10.2 6.6-4.8-.8-3.4-4.3-2.6-8.7.9-4.4.8-8 5.6-7.3 4.8.8 8 5 7.2 9.4z"
      />
      <rect
        width="5.9"
        height="20.5"
        fill="#97E0CE"
        rx="2.9"
        transform="matrix(-.98716 -.15975 .18867 -.98204 96.3 77.2)"
      />
    </svg>
  );
}

export function MicIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 150 150"
      aria-labelledby="micIcon"
    >
      <title id="micIcon">Microphone Icon</title>
      <path fill="#97E0CE" d="M0 75a75 75 0 11150 0A75 75 0 010 75z" />
      <g clipPath="url(#mic-icon-clip0)">
        <path fill="#185941" d="M78 94.6h-7v24.6h7V94.6z" />
        <path
          fill="#fff"
          d="M98 116.4c0-2-1.6-3.6-3.5-3.6h-40c-2 0-3.5 1.6-3.5 3.6s1.6 3.6 3.5 3.6h40c2 0 3.5-1.6 3.5-3.6z"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M51.7 73c2.1 0 3.8 1.7 3.8 3.8 0 8.4 8 15.9 18.7 15.9h.6c10.7 0 18.7-7.5 18.7-16 0-2 1.7-3.7 3.8-3.7 2.1 0 3.8 1.7 3.8 3.8C101.1 90 89 100 74.8 100h-.6c-14.1 0-26.3-10-26.3-23.3 0-2 1.7-3.8 3.8-3.8z"
          clipRule="evenodd"
        />
        <path
          fill="#185941"
          d="M74.5 27.9c-8.7 0-15.8 6.3-15.8 14v32.5c0 7.7 7 14 15.8 14 8.7 0 15.8-6.3 15.8-14V42c0-7.7-7-14-15.8-14z"
        />
      </g>
      <path
        fill="#fff"
        d="M73.3 70.3v-2.7a8.3 8.3 0 01-5.6-3.2l2-2c1 1.3 2.2 2.1 3.6 2.4v-5c-1.6-.3-3-.8-3.8-1.7-1-.9-1.4-2-1.4-3.5 0-1.3.5-2.4 1.5-3.3 1-1 2.2-1.4 3.7-1.6v-2.6h2.4v2.7c2 .3 3.6 1.2 5 2.6l-2 2.2a6 6 0 00-3-2v4.6c2 .3 3.3 1 4.2 1.9 1 1 1.4 2.1 1.4 3.5s-.5 2.6-1.5 3.5c-1 .9-2.3 1.4-4 1.6v2.6h-2.5zm5-7.6c0-1.3-.8-2-2.6-2.5V65c.9-.1 1.5-.4 2-.8.4-.4.6-.9.6-1.5zm-7.2-8.1c0 1.1.7 1.9 2.2 2.2v-4.4c-.7.1-1.3.4-1.6.8-.4.4-.6.9-.6 1.4z"
      />
      <defs>
        <clipPath id="mic-icon-clip0">
          <path
            fill="#fff"
            d="M0 0h65.9v93H0z"
            transform="translate(41.5 27)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ClockIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 150 150"
      aria-labelledby="clockIcon"
    >
      <title id="clockIcon">Clock Icon</title>
      <rect width="150" height="150" fill="#97E0CE" rx="75" />
      <rect
        width="97.6"
        height="97.6"
        x="26.2"
        y="26.2"
        stroke="#185941"
        strokeWidth="6"
        rx="48.8"
      />
      <rect
        width="78.1"
        height="78.1"
        x="35.9"
        y="35.9"
        stroke="#fff"
        strokeDasharray="1 20"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        rx="39.1"
      />
      <path
        stroke="#185941"
        strokeLinecap="round"
        strokeWidth="6"
        d="M76.5 48.8v28.5M75 78H54.8"
      />
      <circle cx="104.5" cy="108.9" r="19.6" fill="#fff" />
      <path
        fill="#185941"
        fillRule="evenodd"
        d="M105 103.4a8 8 0 00-3.3-2.1c-1.6-.6-3.6-.6-5.2.9-2.4 2.1-2.3 5.5-.7 8.7 1.6 3.2 4.9 6.2 9 7.8h.4c4-1.6 7.1-4.6 8.8-7.8 1.6-3.2 1.8-6.6-.5-8.8-1.6-1.4-3.6-1.4-5.2-.8a8.2 8.2 0 00-3.3 2.1z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function MixerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 150 150"
      aria-labelledby="mixerIcon"
    >
      <title id="mixerIcon">Mixer Icon</title>
      <rect width="150" height="150" fill="#97E0CE" rx="75" />
      <rect width="6" height="75" x="33" y="37.5" fill="#185941" rx="3" />
      <rect width="6.8" height="75" x="58.5" y="37.5" fill="#185941" rx="3.4" />
      <rect width="6.8" height="75" x="84" y="37.5" fill="#185941" rx="3.4" />
      <rect width="6" height="75" x="110.3" y="37.5" fill="#185941" rx="3" />
      <rect
        width="6"
        height="21"
        x="123.8"
        y="49.5"
        fill="#fff"
        rx="3"
        transform="rotate(90 123.8 49.5)"
      />
      <rect
        width="6"
        height="21"
        x="98.3"
        y="78.8"
        fill="#fff"
        rx="3"
        transform="rotate(90 98.3 78.8)"
      />
      <rect
        width="6"
        height="21"
        x="72.8"
        y="66"
        fill="#fff"
        rx="3"
        transform="rotate(90 72.8 66)"
      />
      <rect
        width="6"
        height="21"
        x="46.5"
        y="93.8"
        fill="#fff"
        rx="3"
        transform="rotate(90 46.5 93.8)"
      />
    </svg>
  );
}

export function AdsWaveSVG() {
  return (
    <svg
      viewBox="0 0 375 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="adsWaveIcon"
    >
      <title id="adsWaveIcon">AdsWave Icon</title>
      <g>
        <path
          d="M805.902 273.241C714.141 273.241 714.141 173.876 622.38 173.876C530.62 173.876 530.62 273.241 438.859 273.241C347.098 273.241 347.098 173.876 255.338 173.876C163.614 173.876 163.614 273.241 71.8533 273.241C-19.9073 273.241 -19.9073 173.876 -111.668 173.876C-203.392 173.876 -203.392 273.241 -295.152 273.241C-386.913 273.241 -386.913 173.876 -478.637 173.876C-570.398 173.876 -570.398 273.241 -662.158 273.241C-753.919 273.241 -753.919 173.876 -845.643 173.876C-937.403 173.876 -937.403 273.241 -1029.13 273.241C-1120.89 273.241 -1120.89 173.876 -1212.61 173.876C-1304.37 173.876 -1304.37 273.241 -1396.13 273.241C-1487.64 273.241 -1487.86 174.339 -1578.99 173.892V136.695C-1419.02 136.364 -1418.83 0 -1258.46 0C-1097.89 0 -1097.89 136.711 -937.33 136.711C-776.767 136.711 -776.767 0 -616.205 0C-455.642 0 -455.642 136.711 -295.079 136.711C-134.516 136.711 -134.516 0 26.0464 0C186.609 0 186.609 136.711 347.172 136.711C507.735 136.711 507.735 0 668.297 0C828.86 0 828.86 136.711 989.423 136.711V173.892C897.662 173.876 897.662 273.241 805.902 273.241Z"
          fill="#185941"
        />
      </g>
    </svg>
  );
}

export function HeaderWaveIcon() {
  return (
    <svg
      viewBox="0 0 1440 188"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="headerWaveIcon"
      className="span-header-wave-icon"
    >
      <title id="headerWaveIcon">Header Wave Icon</title>
      <mask
        id="mask0-header-wave"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="1440"
        height="188"
      >
        <rect width="1440" height="188" fill="#185941" />
      </mask>
      <g mask="url(#mask0-header-wave)">
        <path
          d="M1829.06 369C1607.59 369 1607.59 235.539 1386.12 235.539C1164.66 235.539 1164.66 369 943.188 369C721.719 369 721.719 235.539 500.25 235.539C278.87 235.539 278.87 369 57.4011 369C-164.068 369 -164.068 235.539 -385.536 235.539C-606.917 235.539 -606.917 369 -828.385 369C-1049.85 369 -1049.85 235.539 -1271.23 235.539C-1492.7 235.539 -1492.7 369 -1714.17 369C-1935.64 369 -1935.64 235.539 -2157.02 235.539C-2378.49 235.539 -2378.49 369 -2599.87 369C-2821.34 369 -2821.34 235.539 -3042.72 235.539C-3264.19 235.539 -3264.19 369 -3485.66 369C-3706.5 369 -3707.04 236.161 -3927 235.562V185.6C-3540.89 185.156 -3540.45 2 -3153.36 2C-2765.84 2 -2765.84 185.622 -2378.31 185.622C-1990.79 185.622 -1990.79 2 -1603.26 2C-1215.73 2 -1215.73 185.622 -828.208 185.622C-440.682 185.622 -440.682 2 -53.1562 2C334.37 2 334.37 185.622 721.896 185.622C1109.42 185.622 1109.42 2 1496.95 2C1884.47 2 1884.47 185.622 2272 185.622V235.562C2050.53 235.539 2050.53 369 1829.06 369Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

export function QuoteWaveIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 1440 297"
      aria-labelledby="quoteWaveIcon"
    >
      <title id="quoteWaveIcon">Quote Wave Icon</title>
      <path
        fill="#97E0CE"
        d="M1810.9 152.5a290.2 290.2 0 0 0-68.4 12.5c-25.2 8-47 19.5-67 32-19.8 12.6-38 26-57.6 38.6a312.7 312.7 0 0 1-65.8 33.1 309 309 0 0 1-104.9 16.3c-4.5 0-9 0-13.5-.2-32-1-63.3-6.3-91.3-16.1a314.1 314.1 0 0 1-65.9-33.1c-19.5-12.6-37.7-26-57.5-38.5-20-12.6-41.8-24-67-32.1-12.8-4.1-26.2-7.2-40-9.3-18.6-3-38.2-3-56.9 0a267.6 267.6 0 0 0-39.9 9.3c-25.2 8-47 19.5-67 32-19.8 12.6-38 26-57.6 38.6a312.6 312.6 0 0 1-65.8 33.1A309 309 0 0 1 719.9 285c-4.5 0-9 0-13.5-.2-32-1-63.3-6.3-91.3-16.1a314.3 314.3 0 0 1-65.9-33.1c-19.6-12.6-37.7-26-57.5-38.5-20-12.6-41.8-24-67-32.1-12.8-4.1-26.2-7.2-40-9.3-18.6-3-38.2-3-56.9 0A267.6 267.6 0 0 0 288 165c-25.2 8-47 19.5-67 32-19.8 12.6-38 26-57.6 38.6a312.6 312.6 0 0 1-65.8 33.1A309 309 0 0 1-7.4 285c-4.5 0-9 0-13.5-.2-32-1-63.2-6.3-91.3-16.1a314 314 0 0 1-65.8-33.1c-19.6-12.6-37.8-26-57.6-38.5-20-12.6-41.8-24-67-32.1a290.2 290.2 0 0 0-68.4-12.5v-7c23.7-1.6 46.9-5.6 68.4-12.4 25.2-8.1 47-19.6 67-32.2 19.8-12.4 38-25.9 57.6-38.5a313.5 313.5 0 0 1 65.8-33.1A309 309 0 0 1-7.3 13 308.3 308.3 0 0 1 97.6 29.3a313.3 313.3 0 0 1 65.8 33.1C183 75 201 88.4 220.9 101c20 12.6 41.8 24 67 32.2a266 266 0 0 0 40 9.3c18.6 2.9 38.2 2.9 56.9 0 13.7-2.2 27.1-5.3 39.9-9.3 25.3-8.1 47-19.6 67-32.2 19.8-12.4 38-25.9 57.6-38.5a313.5 313.5 0 0 1 65.8-33.1A309 309 0 0 1 720 13a308.3 308.3 0 0 1 104.9 16.3 313.3 313.3 0 0 1 65.8 33.1c19.6 12.6 37.8 26 57.6 38.5 20 12.6 41.8 24 67 32.2 10.5 3.3 21.5 6 32.8 8 23.3 4.3 47.8 4.3 71.1 0A260.8 260.8 0 0 0 1219 101c19.9-12.4 38-25.9 57.6-38.5a313.6 313.6 0 0 1 65.9-33.1A308.9 308.9 0 0 1 1447.3 13a308.3 308.3 0 0 1 104.9 16.3 313.3 313.3 0 0 1 65.8 33.1c19.6 12.6 37.8 26 57.6 38.5a292 292 0 0 0 67 32.2 290 290 0 0 0 68.4 12.4"
      />
    </svg>
  );
}

export function AmbassadorIcon({ screen }: { screen: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 185 185"
      aria-labelledby={`ambassadorIcon${screen ? `-${screen}` : ''}`}
    >
      <title id={`ambassadorIcon${screen ? `-${screen}` : ''}`}>
        Ambassador Icon
      </title>
      <circle cx="92.5" cy="92.5" r="92.5" fill="#97E0CE" />
      <path
        fill="#fff"
        d="M158.4 89c0 7.5-6 13.6-13.6 13.6h-17V75.5h17c7.5 0 13.6 6 13.6 13.5Z"
      />
      <path
        fill="#185941"
        d="M74.2 114.3c0 2.6-2.1 4.7-4.7 4.7H47.1v-9.4h22.4c2.6 0 4.7 2.1 4.7 4.7Z"
      />
      <path
        fill="#185941"
        d="M60.9 143a8.8 8.8 0 0 1-10.9-6.2l-8.6-32.4 17-4.6 8.7 32.4a8.8 8.8 0 0 1-6.2 10.8ZM145.4 133.1V45a4 4 0 0 0-5.5-3.7L64.5 71.8c-2.1.8-3.1 3.2-2.5 5.4 1.5 5 3.3 14.4.3 23.5-.7 2.3.2 4.8 2.4 5.7l75.2 30.4a4 4 0 0 0 5.5-3.7Z"
      />
      <path
        fill="#fff"
        d="M27.1 85.6C27.1 74.8 36 66 46.6 66H79V112H46.6a19.5 19.5 0 0 1-19.5-19.5v-7Z"
      />
      <path
        fill="#97E0CE"
        d="M131 79.6a6 6 0 0 0-3.6-.2c-.8.2-1.6.7-2.3 1.2-.6.6-1.1 1.4-1.4 2.2-1.6 4-.2 10.8-.8 10.8-.5 0-2.3-6.3-4.7-13-2.3-6.5-4.4-13.3-8-12.8-3.3.5-2.3 8.3-1 15.6 1.1 6.6 2.5 12.8 1.7 12.8-1.4 0-5.9-18.3-10.5-17.6-4.6.7 1.3 20.8 0 20.9-1 0-3.4-12.3-7.2-11.7-2.8.4-.3 10-.2 12.6 0 .7.3 2-.8 2h-2.1v1.8h3.5c.3 0 .6 0 1-.2l.5-.7c1-2.3-1.5-11.7-1-11.8.5 0 1.3 2.8 2.6 6 1.2 3.4 2.4 6.7 4.7 6.7 5 0 0-18.5.9-18.5.5 0 2 3.8 3.5 8 2 5 4.3 10.5 7.1 10.5 3.4 0 2.3-7.2 1.2-14-.9-6-2-11.6-1.4-11.6 1.3 0 6.1 25.7 12 25.7 2.8 0 2.8-5.4 2.8-11.2 0-4-.3-7.8 2.4-8.7a3.6 3.6 0 0 1 2.6.4l-1.4-5.1"
      />
    </svg>
  );
}

export function SPANIcon({ screen }: { screen: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 185 185"
      aria-labelledby={`spanIcon${screen ? `-${screen}` : ''}`}
    >
      <title id={`spanIcon${screen ? `-${screen}` : ''}`}>SPAN Icon</title>
      <circle cx="92.5" cy="92.5" r="92.5" fill="#97E0CE" />
      <circle cx="92.8" cy="93.6" r="41.7" fill="#185941" />
      <rect width="20.1" height="31.6" x="82.7" y="39" fill="#185941" rx="3" />
      <rect
        width="20.1"
        height="31.6"
        x="82.7"
        y="115.2"
        fill="#185941"
        rx="3"
      />
      <rect
        width="20.1"
        height="31.6"
        x="145.9"
        y="83.6"
        fill="#185941"
        rx="3"
        transform="rotate(90 146 83.6)"
      />
      <rect
        width="20.1"
        height="31.6"
        x="72.6"
        y="83.6"
        fill="#185941"
        rx="3"
        transform="rotate(90 72.6 83.6)"
      />
      <rect
        width="20.2"
        height="31.7"
        x="136"
        y="123.5"
        fill="#185941"
        rx="3"
        transform="rotate(135 136 123.5)"
      />
      <rect
        width="20.3"
        height="31.7"
        x="85.4"
        y="70.7"
        fill="#185941"
        rx="3"
        transform="rotate(135 85.4 70.7)"
      />
      <rect
        width="20.3"
        height="31.7"
        x="64"
        y="137.8"
        fill="#185941"
        rx="3"
        transform="rotate(-135 64 137.8)"
      />
      <rect
        width="19.3"
        height="31.7"
        x="114.2"
        y="84.6"
        fill="#185941"
        rx="3"
        transform="rotate(-135 114.2 84.6)"
      />
      <circle cx="92.8" cy="93.6" r="25.9" fill="#97E0CE" />
    </svg>
  );
}

export function PremiumSponsorshipIcon({ screen }: { screen: string }) {
  return (
    <svg
      viewBox="0 0 185 185"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={`premiumSponsorshipIcon${screen ? `-${screen}` : ''}`}
    >
      <title id={`premiumSponsorshipIcon${screen ? `-${screen}` : ''}`}>
        Premium Sponsorship Icon
      </title>
      <circle cx="92.5" cy="92.5" r="92.5" fill="#97E0CE" />
      <path
        d="M91.957 139.676C102.652 128.229 126.678 120.309 126.678 96.3626"
        stroke="#185941"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M92.0766 139.676C81.3812 128.229 57.3242 120.309 57.3242 96.3626"
        stroke="#185941"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M92.0195 139.83V151.68"
        stroke="#185941"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="71" y="32" width="42" height="82" rx="21" fill="#185941" />
      <path
        d="M66 152H117.865"
        stroke="white"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.6172 54.4638C65.6172 58.6714 82.6679 50.1325 82.6679 54.4638C82.6679 58.7951 65.6172 67.2412 65.6172 71.4797C65.6172 75.7182 82.6679 67.1484 82.6679 71.4797C82.6679 75.811 65.6172 84.257 65.6172 88.4955"
        fill="#97E0CE"
      />
      <path
        d="M65.6172 54.4638C65.6172 58.6714 82.6679 50.1325 82.6679 54.4638C82.6679 58.7951 65.6172 67.2412 65.6172 71.4797C65.6172 75.7182 82.6679 67.1484 82.6679 71.4797C82.6679 75.811 65.6172 84.257 65.6172 88.4955"
        stroke="#97E0CE"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M118.57 55.7084C118.57 59.9469 101.52 68.4857 101.52 72.7242C101.52 76.9627 118.57 68.3929 118.57 72.7242C118.57 77.0555 101.52 85.5635 101.52 89.7401C101.52 93.9167 118.384 83.5525 118.384 90.1113"
        fill="#97E0CE"
      />
      <path
        d="M118.57 55.7084C118.57 59.9469 101.52 68.4857 101.52 72.7242C101.52 76.9627 118.57 68.3929 118.57 72.7242C118.57 77.0555 101.52 85.5635 101.52 89.7401C101.52 93.9167 118.384 83.5525 118.384 90.1113"
        stroke="#97E0CE"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PodcastSubscriptionsIcon({ screen }: { screen: string }) {
  return (
    <svg
      viewBox="0 0 185 184"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={`podcastSubscriptionIcon${screen ? `-${screen}` : ''}`}
    >
      <title id={`podcastSubscriptionIcon${screen ? `-${screen}` : ''}`}>
        Podcast Subscription Icon
      </title>
      <path
        d="M93.0405 184C143.277 184 184.001 142.81 184.001 92C184.001 41.1898 143.277 3.05176e-05 93.0405 3.05176e-05C42.8044 3.05176e-05 2.08008 41.1898 2.08008 92C2.08008 142.81 42.8044 184 93.0405 184Z"
        fill="#97E0CE"
      />
      <path
        d="M87.3223 141.312V130.062C77.7585 128.87 69.8926 124.314 63.7246 116.393L72.1449 107.771C76.3724 113.519 81.4316 117.059 87.3223 118.391V97.3622C80.392 96.1005 75.021 93.6472 71.2094 90.0022C67.3977 86.2872 65.4918 81.4506 65.4918 75.4925C65.4918 69.7447 67.5363 65.0133 71.6252 61.2983C75.7834 57.5832 81.0158 55.4103 87.3223 54.7794V43.6343H97.302V54.9897C105.203 56.2514 112.133 60.0015 118.093 66.24L109.465 75.4925C105.722 71.0064 101.668 68.1325 97.302 66.8708V86.4274C105.133 87.6891 110.955 90.2826 114.766 94.208C118.647 98.1333 120.588 103.11 120.588 109.138C120.588 114.886 118.509 119.688 114.351 123.543C110.262 127.328 104.579 129.571 97.302 130.272V141.312H87.3223ZM108.113 109.349C108.113 104.091 104.51 100.657 97.302 99.0445V119.022C100.767 118.601 103.435 117.515 105.307 115.762C107.178 114.01 108.113 111.872 108.113 109.349ZM77.9664 75.1771C77.9664 80.0838 81.0851 83.2381 87.3223 84.64V66.1348C84.273 66.6255 81.9513 67.747 80.3574 69.4994C78.7634 71.1817 77.9664 73.0743 77.9664 75.1771Z"
        fill="#185941"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.6382 21.0286C88.6382 18.5962 90.6101 16.6243 93.0425 16.6243C134.275 16.6243 167.616 50.4185 167.616 92C167.616 133.581 134.275 167.376 93.0425 167.376C51.8095 167.376 18.4688 133.581 18.4688 92C18.4688 89.5676 20.4406 87.5957 22.873 87.5957C25.3054 87.5957 27.2773 89.5676 27.2773 92C27.2773 128.811 56.7684 158.567 93.0425 158.567C129.317 158.567 158.808 128.811 158.808 92C158.808 55.1886 129.317 25.4328 93.0425 25.4328C90.6101 25.4328 88.6382 23.461 88.6382 21.0286Z"
        fill="white"
      />
      <path
        d="M13.8021 92.6014C11.5091 92.6014 10.0833 90.1037 11.2298 88.0952L21.0541 70.8846C22.2055 68.8675 25.0852 68.8568 26.2317 70.8653L36.056 88.0759C37.2025 90.0844 35.7534 92.6014 33.4506 92.6014L13.8021 92.6014Z"
        fill="white"
      />
    </svg>
  );
}

export function ListenerSupoortIcon({ screen }: { screen: string }) {
  return (
    <svg
      viewBox="0 0 183 184"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={`listenerSupportIcon${screen ? `-${screen}` : ''}`}
    >
      <title id={`listenerSupportIcon${screen ? `-${screen}` : ''}`}>
        Listener Support Icon
      </title>
      <path
        d="M91.0464 184C141.282 184 182.007 142.81 182.007 91.9999C182.007 41.1897 141.282 -3.05176e-05 91.0464 -3.05176e-05C40.8103 -3.05176e-05 0.0859375 41.1897 0.0859375 91.9999C0.0859375 142.81 40.8103 184 91.0464 184Z"
        fill="#97E0CE"
      />
      <circle cx="91.2022" cy="75.235" r="21.9542" fill="#185941" />
      <path
        d="M90.937 98.4418C74.089 98.4418 59.9572 111.985 56.1308 130.233C54.9973 135.638 59.5865 140.165 65.1094 140.165H116.765C122.287 140.165 126.877 135.638 125.743 130.233C121.917 111.985 107.785 98.4418 90.937 98.4418Z"
        fill="#185941"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.9336 67.9922C65.9336 54.1056 77.191 42.8482 91.0776 42.8482C104.964 42.8482 116.222 54.1055 116.222 67.9922V88.8134H112.063V67.9922C112.063 56.4022 102.668 47.0066 91.0776 47.0066C79.4876 47.0066 70.092 56.4022 70.092 67.9922V88.8134H65.9336V67.9922Z"
        fill="#185941"
      />
      <path
        d="M58.0064 84.9045C57.0702 80.0315 60.6154 75.3847 65.9249 74.5254C71.2344 73.6662 71.1702 77.7497 72.1064 82.6226C73.0426 87.4956 74.6247 91.3127 69.3152 92.1719C64.0057 93.0312 58.9426 89.7774 58.0064 84.9045Z"
        fill="white"
      />
      <rect
        width="6.49248"
        height="22.761"
        rx="3.24624"
        transform="matrix(-0.987157 0.159752 -0.188672 -0.98204 74.8926 93.6952)"
        fill="#97E0CE"
      />
      <path
        d="M124.15 84.9044C123.214 89.7773 118.151 93.0311 112.841 92.1718C107.532 91.3126 109.114 87.4955 110.05 82.6226C110.986 77.7496 110.922 73.6661 116.232 74.5253C121.541 75.3846 125.086 80.0314 124.15 84.9044Z"
        fill="white"
      />
      <rect
        width="6.49249"
        height="22.761"
        rx="3.24624"
        transform="matrix(-0.987157 -0.159752 0.188672 -0.98204 113.676 94.7324)"
        fill="#97E0CE"
      />
      <circle cx="149.014" cy="79.0381" r="11.7244" fill="#185941" />
      <path
        d="M148.872 91.4315C141.306 91.4315 134.767 96.5447 131.662 103.965C129.53 109.06 134.215 113.713 139.738 113.713H158.005C163.528 113.713 168.214 109.06 166.082 103.965C162.977 96.5447 156.437 91.4315 148.872 91.4315Z"
        fill="#185941"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M135.527 75.17C135.527 67.754 141.539 61.7421 148.955 61.7421C156.371 61.7421 162.383 67.754 162.383 75.17V86.2894H160.163V75.17C160.163 68.9805 155.145 63.9628 148.955 63.9628C142.766 63.9628 137.748 68.9805 137.748 75.17V86.2894H135.527V75.17Z"
        fill="#185941"
        stroke="#185941"
      />
      <path
        d="M131.292 84.2015C130.792 81.5991 132.685 79.1175 135.521 78.6587C138.356 78.1998 138.322 80.3806 138.822 82.9829C139.322 85.5853 140.167 87.6238 137.331 88.0826C134.496 88.5415 131.792 86.8039 131.292 84.2015Z"
        fill="white"
      />
      <rect
        width="3.46725"
        height="12.1553"
        rx="1.73363"
        transform="matrix(-0.987157 0.159752 -0.188672 -0.98204 140.311 88.8961)"
        fill="#97E0CE"
      />
      <path
        d="M166.618 84.2019C166.118 86.8042 163.414 88.5419 160.579 88.083C157.743 87.6241 158.588 85.5857 159.088 82.9833C159.588 80.3809 159.554 78.2002 162.389 78.659C165.225 79.1179 167.118 81.5995 166.618 84.2019Z"
        fill="white"
      />
      <rect
        width="3.46726"
        height="12.1553"
        rx="1.73363"
        transform="matrix(-0.987157 -0.159752 0.188672 -0.98204 161.021 89.4504)"
        fill="#97E0CE"
      />
      <circle cx="32.2537" cy="79.0383" r="11.7244" fill="#185941" />
      <path
        d="M32.1119 91.4317C24.5466 91.4317 18.0069 96.5449 14.9018 103.966C12.77 109.06 17.4557 113.714 22.9785 113.714H41.2453C46.7682 113.714 51.4538 109.06 49.322 103.966C46.217 96.5449 39.6772 91.4317 32.1119 91.4317Z"
        fill="#185941"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7676 75.1702C18.7676 67.7541 24.7795 61.7422 32.1955 61.7422C39.6116 61.7422 45.6235 67.7541 45.6235 75.1702V86.2895H43.4027V75.1702C43.4027 68.9806 38.3851 63.963 32.1955 63.963C26.006 63.963 20.9883 68.9806 20.9883 75.1702V86.2895H18.7676V75.1702Z"
        fill="#185941"
        stroke="#185941"
      />
      <path
        d="M14.5323 84.2016C14.0323 81.5993 15.9256 79.1177 18.7611 78.6588C21.5966 78.1999 21.5623 80.3807 22.0623 82.983C22.5623 85.5854 23.4071 87.6239 20.5717 88.0828C17.7362 88.5416 15.0323 86.804 14.5323 84.2016Z"
        fill="white"
      />
      <rect
        width="3.46725"
        height="12.1553"
        rx="1.73363"
        transform="matrix(-0.987157 0.159752 -0.188672 -0.98204 23.5508 88.8962)"
        fill="#97E0CE"
      />
      <path
        d="M49.8583 84.202C49.3584 86.8044 46.6544 88.542 43.819 88.0831C40.9835 87.6243 41.8284 85.5858 42.3283 82.9834C42.8283 80.3811 42.794 78.2003 45.6295 78.6592C48.465 79.118 50.3583 81.5996 49.8583 84.202Z"
        fill="white"
      />
      <rect
        width="3.46726"
        height="12.1553"
        rx="1.73363"
        transform="matrix(-0.987157 -0.159752 0.188672 -0.98204 44.2617 89.4506)"
        fill="#97E0CE"
      />
    </svg>
  );
}

export function AdsByAnchorIcon({ id }: { id: string }) {
  return (
    <svg
      viewBox="0 0 500 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={id}
      className="ads-by-anchor-icon"
    >
      <title id={id}>Ads By Anchor Icon</title>
      <path
        d="M281.804 55.0281H269.703L265.312 44.1994H244.005L239.676 55.0281H227.615L249.127 0H260.245L281.804 55.0281ZM247.877 33.8344H261.542L254.706 15.856L247.877 33.8344Z"
        fill="white"
      />
      <path
        d="M296.735 55.0281H285.617V16.5713H296.578V19.2598C299.02 16.9035 302.292 15.6043 305.686 15.6437C315.121 15.6437 321.313 21.7675 321.313 32.6788V55.0281H310.195V33.52C310.195 29.444 308.344 25.989 303.842 25.989C298.579 25.989 296.766 29.9196 296.766 35.8154L296.727 55.0753"
        fill="white"
      />
      <path
        d="M365.572 40.0408C363.763 49.3877 356.695 55.9007 346.328 55.9007C334.699 55.9007 326.066 47.3399 326.066 35.7997C326.066 24.2595 334.715 15.624 346.328 15.624C356.455 15.624 363.523 21.913 364.939 31.0122H352.685C352.266 29.5658 351.375 28.3011 350.154 27.4199C348.933 26.5387 347.452 26.0917 345.947 26.1501C341.229 26.1501 337.459 30.1514 337.459 35.7997C337.459 41.4479 341.229 45.4611 346.108 45.4611C347.751 45.5181 349.364 45.0116 350.679 44.0256C351.994 43.0396 352.932 41.6335 353.337 40.0408H365.595"
        fill="white"
      />
      <path
        d="M381.26 55.0281H370.143V0H381.26V18.7646C383.782 16.6921 386.956 15.5783 390.22 15.6201C399.655 15.6201 405.838 21.744 405.838 32.6552V55.0281H394.721V33.52C394.721 29.444 392.869 25.989 388.356 25.989C383.096 25.989 381.28 29.9196 381.28 35.8154L381.252 55.0753"
        fill="white"
      />
      <path
        d="M431.011 15.624C442.628 15.624 451.505 24.2713 451.505 35.7997C451.505 47.3281 442.628 55.9007 431.011 55.9007C419.394 55.9007 410.51 47.3399 410.51 35.7997C410.51 24.2595 419.387 15.624 431.011 15.624ZM431.011 45.5357C436.263 45.5357 440.116 41.4519 440.116 35.7997C440.116 30.1475 436.263 26.0636 431.011 26.0636C425.759 26.0636 421.895 30.1514 421.895 35.7997C421.895 41.4479 425.751 45.5357 431.011 45.5357Z"
        fill="white"
      />
      <path
        d="M481.799 29.7505C479.816 27.8922 477.217 26.83 474.499 26.7672C471.114 26.7672 467.344 28.6224 467.344 34.2353V55.0281H456.227V16.5713H467.187V19.7865C467.112 19.7865 469.392 16.0131 474.888 16.0131C476.172 15.9574 477.452 16.1765 478.644 16.6558C479.836 17.1351 480.912 17.8634 481.799 18.792V29.7505Z"
        fill="white"
      />
      <path
        d="M491.575 54.8079C490.448 54.8095 489.332 54.5849 488.293 54.1476C487.292 53.7216 486.381 53.1078 485.611 52.3395C485.23 51.9571 484.885 51.54 484.581 51.0935C484.274 50.6415 484.011 50.1611 483.795 49.6588C483.357 48.6208 483.131 47.5055 483.131 46.3788C483.131 45.252 483.357 44.1367 483.795 43.0987C484.218 42.0971 484.831 41.1867 485.6 40.4181C486.371 39.6526 487.281 39.0404 488.281 38.6139C489.319 38.1756 490.434 37.9497 491.561 37.9497C492.688 37.9497 493.804 38.1756 494.842 38.6139C496.349 39.25 497.639 40.3112 498.553 41.668C498.86 42.1187 499.124 42.5978 499.339 43.0987C499.775 44.1374 500 45.2524 500 46.3788C500 47.5051 499.775 48.6202 499.339 49.6588C499.124 50.161 498.86 50.6414 498.553 51.0935C497.638 52.4491 496.349 53.5101 494.842 54.1476C493.808 54.5831 492.697 54.8076 491.575 54.8079ZM491.575 38.665C490.049 38.665 488.557 39.1175 487.288 39.9653C486.019 40.8132 485.03 42.0182 484.446 43.4281C483.861 44.8379 483.709 46.3893 484.006 47.886C484.304 49.3827 485.039 50.7575 486.118 51.8366C487.198 52.9156 488.573 53.6505 490.07 53.9482C491.567 54.2459 493.118 54.0931 494.528 53.5091C495.938 52.9251 497.144 51.9362 497.992 50.6674C498.84 49.3985 499.292 47.9068 499.292 46.3807C499.29 44.335 498.476 42.3737 497.03 40.9272C495.583 39.4807 493.621 38.6671 491.575 38.665Z"
        fill="white"
      />
      <path
        d="M488.033 51.0975V41.6641H492.039C492.781 41.6297 493.523 41.716 494.237 41.9196C494.696 42.0946 495.083 42.4202 495.334 42.8433C495.605 43.2902 495.742 43.8062 495.727 44.329C495.737 44.8121 495.616 45.289 495.377 45.7087C495.299 45.8491 495.207 45.9808 495.102 46.1017C494.681 46.5425 494.13 46.8361 493.529 46.9389C493.714 47.1276 493.977 47.4067 494.272 47.7644C494.673 48.245 495.036 48.7562 495.357 49.2934C495.597 49.6864 495.99 50.3192 496.509 51.1329H494.229L492.853 49.0811C492.55 48.5983 492.215 48.1361 491.85 47.6975C491.694 47.5214 491.497 47.3864 491.276 47.3045C490.964 47.22 490.641 47.1842 490.317 47.1984H489.924V51.1289L488.033 51.0975ZM489.936 45.6576H491.347C491.92 45.687 492.494 45.6474 493.057 45.5397C493.275 45.4723 493.463 45.3339 493.592 45.1466C493.727 44.9361 493.795 44.6891 493.785 44.4391C493.801 44.1543 493.71 43.8738 493.529 43.653C493.341 43.4497 493.088 43.3189 492.814 43.2835C492.656 43.2835 492.196 43.2521 491.422 43.2521H489.936V45.6576Z"
        fill="white"
      />
      <path
        d="M26.823 2.65405L47.1637 54.8843H41.054L36.2855 42.8885H10.8037L6.18418 54.8843H0L20.4152 2.65405H26.823ZM23.5446 9.95586L13.0389 37.4494H34.1993L23.5446 9.95586Z"
        fill="white"
      />
      <path
        d="M52.1552 50.1903C48.9761 46.5145 47.3866 41.9944 47.3866 36.6298C47.3866 31.2652 48.9761 26.745 52.1552 23.0693C55.3342 19.3439 59.4073 17.4812 64.3745 17.4812C69.292 17.4812 73.39 19.3936 76.6684 23.2183V2.65405H82.182V54.8843H76.8919V49.8923C73.5142 53.7667 69.3417 55.7039 64.3745 55.7039C59.4073 55.7039 55.3342 53.866 52.1552 50.1903ZM56.2531 26.6457C54.1172 29.2783 53.0493 32.6063 53.0493 36.6298C53.0493 40.6532 54.1172 43.9813 56.2531 46.6139C58.389 49.2465 61.27 50.5628 64.8961 50.5628C68.5221 50.5628 71.428 49.2465 73.6135 46.6139C75.7991 43.9813 76.8919 40.6532 76.8919 36.6298C76.8919 32.6063 75.7991 29.2783 73.6135 26.6457C71.428 24.0131 68.5221 22.6968 64.8961 22.6968C61.27 22.6968 58.389 24.0131 56.2531 26.6457Z"
        fill="white"
      />
      <path
        d="M104.2 39.7591L98.7612 38.4925C91.8568 36.8533 88.4046 33.3514 88.4046 27.9868C88.4046 24.7085 89.6464 22.1504 92.13 20.3125C94.6136 18.425 97.5691 17.4812 100.996 17.4812C105.864 17.4812 110.186 19.4432 113.961 23.3673L110.235 27.3163C107.255 24.1869 104.051 22.6222 100.624 22.6222C98.637 22.6222 97.0227 23.0941 95.7809 24.0379C94.5391 24.9817 93.9182 26.2235 93.9182 27.7633C93.9182 30.545 95.7312 32.3332 99.3573 33.1279L105.094 34.4691C111.999 36.1082 115.451 39.5356 115.451 44.7512C115.451 47.9799 114.209 50.6125 111.726 52.6491C109.242 54.6856 105.939 55.7039 101.816 55.7039C98.6867 55.7039 95.8057 55.0582 93.1731 53.7667C90.5901 52.4255 88.5536 50.7864 87.0634 48.8491L90.7143 45.0492C93.6947 48.7746 97.3704 50.6373 101.742 50.6373C104.324 50.6373 106.336 50.1406 107.777 49.1472C109.217 48.1537 109.937 46.7877 109.937 45.0492C109.937 42.4166 108.025 40.6532 104.2 39.7591Z"
        fill="white"
      />
      <path
        d="M169.692 23.0693C172.871 26.745 174.461 31.2652 174.461 36.6298C174.461 41.9944 172.871 46.5145 169.692 50.1903C166.513 53.866 162.44 55.7039 157.473 55.7039C152.506 55.7039 148.358 53.7667 145.03 49.8923V54.8843H139.666V2.65405H145.179V23.2183C148.458 19.3936 152.556 17.4812 157.473 17.4812C162.44 17.4812 166.513 19.3439 169.692 23.0693ZM165.594 46.6139C167.73 43.9813 168.798 40.6532 168.798 36.6298C168.798 32.6063 167.73 29.2783 165.594 26.6457C163.459 24.0131 160.578 22.6968 156.952 22.6968C153.325 22.6968 150.42 24.0131 148.234 26.6457C146.098 29.2783 145.03 32.6063 145.03 36.6298C145.03 40.6532 146.098 43.9813 148.234 46.6139C150.42 49.2465 153.325 50.5628 156.952 50.5628C160.578 50.5628 163.459 49.2465 165.594 46.6139Z"
        fill="white"
      />
      <path
        d="M190.697 69.3389H184.662L190.176 55.3314L175.051 18.3753H181.235L193.231 48.7001L205.003 18.3753H211.113L190.697 69.3389Z"
        fill="white"
      />
    </svg>
  );
}
